import { render, staticRenderFns } from "./catalogopac.vue?vue&type=template&id=5a6bf528&scoped=true&"
import script from "./catalogopac.vue?vue&type=script&lang=js&"
export * from "./catalogopac.vue?vue&type=script&lang=js&"
import style0 from "./catalogopac.vue?vue&type=style&index=0&id=5a6bf528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6bf528",
  null
  
)

export default component.exports